// Page routes
export const PREFIX_URL = '';
export const LOCATIONS_URL = '/locations';
export const PHYSICIANS_URL = `/physicians`;
export const LISTING_PAGE = `${PREFIX_URL}/listing`;
export const PROFILE_PAGE = `${PREFIX_URL}/profile`;
export const BOOKING_PAGE = `${PREFIX_URL}/booking`;
export const CONFIRMATION_PAGE = `${PREFIX_URL}/confirmation`;
export const NOT_FOUND = `${PREFIX_URL}/404`;

// Next.js API routes
export const BASE_API_URL = '/physicians/api';
export const TERM_AUTO_COMPLETE_URL = `${BASE_API_URL}/term-auto-complete`;
export const GET_NOT_FOUND_LAYOUT_URL = `${BASE_API_URL}/error-handling/get-not-found-layout`;
// Headers
export const MARKET_SITE_HEADER = 'market-site';
export const MARKET_LEVEL_URL_HEADER = 'market-level-url';
export const USER_DATA_HEADER = 'userdata';

// Sitecore proxy APIs
export const SITECORE_API_URL = '/api/onlineappointmentscheduling';
export const SITECORE_TERM_AUTO_COMPLETE_URL = `${SITECORE_API_URL}/termAutoComplete`;
export const SITECORE_LISTING_URL = `${SITECORE_API_URL}/ProviderSearch`;
export const PROVIDER_URL_TITLE_BY_NPI = `${SITECORE_API_URL}/providerUrlTitleByNpi`;

// Appointment URIs
export const APPOINTMENT_HOLD_URL = 'appointmentHold';
export const APPOINTMENT_SEARCH_URL = 'appointmentSearch';
export const APPOINTMENT_BOOK_URL = 'appointmentBook';

// Address search - Azure Maps API
export const AZ_API_FORMAT = 'json';
export const DEFAULT_AZ_PARAMS = {
  'api-version': '1.0',
  countrySet: 'US',
};
export const FUZZY_PARAMS = {
  ...DEFAULT_AZ_PARAMS,
  typeahead: true,
  limit: 5,
};

// Request params
export const HOST_APP_QUERYPARAM = 'hostApp';
export const FACILITY_COIDS_QUERYPARAM = 'facilityCoids';

// Cookie names
export const SITE_SYMBOL = 'sc_site';
export const FACILITY_COIDS_COOKIE = 'facility_coids';

// Storage keys
export const BOOKING_CONFIRMATION_DATA = 'booking_confirmation_data';
export const INITIAL_HOST_TITLE = 'initialHostTitle';

// Celebrus Data Target Selectors
export const CELEBRUS_TYPEAHEAD_ID = 'consolidated-type-ahead-input';
export const CELEBRUS_APPOINTMENT_LOCATION_CLASSNAMES = 'appt-info-font-18 neu-padding--top-10';
export const CELEBRUS_CALENDAR_HEADER_CLASSNAMES =
  'hca-calendar--title d-flex align-content-center hca-padding-bottom-10';
export const CELEBRUS_REASON_FOR_VISIT_TEXTAREA_ID = 'visit_reason';
export const CELEBRUS_PATIENT_ADDRESS_ID = 'patient_address1';
export const CELEBRUS_PATIENT_ADDRESS2_ID = 'patient_address2';
export const CELEBRUS_PATIENT_CITY_ID = 'patient_city';
export const CELEBRUS_PATIENT_DOB_ID = 'patient_dob';
export const CELEBRUS_PATIENT_EMAIL_ID = 'patient_email';
export const CELEBRUS_PATIENT_FIRST_NAME_ID = 'patient_first_name';
export const CELEBRUS_PATIENT_PHONE_ID = 'patient_phone';
export const CELEBRUS_PATIENT_LAST_NAME_ID = 'patient_last_name';
export const CELEBRUS_PATIENT_ZIP_ID = 'patient_zip';
export const CELEBRUS_APPOINTMENT_TYPE_ID = 'oas-appt-type';
export const CELEBRUS_APPOINTMENT_REASON_FOR_VISIT_ID = 'oas-appt-reason';
export const CELEBRUS_APPOINTMENT_SELF_PAY = 'oas-selfpay';
export const CELEBRUS_CONTINUE_BUTTON_ID_2 = 'oas-step2';
export const CELEBRUS_CONTINUE_BUTTON_ID_3 = 'oas-step3';
export const CELEBRUS_CONTINUE_BUTTON_ID_4 = 'oas-step4';
export const CELEBRUS_BOOK_BUTTON_PREFIX = 'oas-step1-list';
export const CELEBRUS_BOOK_BUTTON_PREFIX_EXTERNAL = 'oas-step1-list-external';
export const CELEBRUS_BOOK_BUTTON_ID = 'oas-step1-profile';
export const CELEBRUS_BOOK_EXTERNAL_BUTTON_ID = 'oas-step1-profile-external';

// Azure Maps Address Search Params
export const AZ_REQUEST_PARAMS = {
  entityType: ['PostalCodeArea', 'Municipality', 'CountrySubdivision'],
  useFuzzySearchEndpoint: true,
  maxFuzzyLevel: 4,
};
